import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogData} from '../cars-grid/cars-grid.component';

@Component({
  selector: 'app-car-dialog-overview',
  templateUrl: './car-dialog-overview.component.html',
  styleUrls: ['./car-dialog-overview.component.css']
})
export class CarDialogOverviewComponent {

  constructor(
    public dialogRef: MatDialogRef<CarDialogOverviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
